//@flow
import React from 'react';
import OutOfStockEmailForm from './OutOfStockEmailForm.react';
import StockRemindersActions from '../../Actions/stockReminders';
import CustomerModel from '../../Stores/Customer/customerModel';

type Props = {
  reminderSet:?boolean,
  sku:string,
  email:?string,
  customer:?CustomerModel,
  comingSoon:?boolean,
};

export default class OutOfStockReminderTooltip extends React.Component<Props> {
  getHeaderText() {
    if (this.props.comingSoon) {
      return "This item is coming soon!";
    }

    return 'Sorry, this item is sold out.';
  }

  getText() {
    const email = this.props.email ? `at ${this.props.email} ` : '';
    if (this.props.comingSoon) {
      return (
        <div className="reminder-text">
          {`Sign up ${email}to get early access when it's available`}
        </div>
      ) ;
    }

    return (
      <div className="reminder-text">
        {`We can email you ${email}when it's back in stock.`}
      </div>
    ) ;
  }

  getReminderText() {
    const email = this.props.email ? `at ${this.props.email} ` : '';
    if (this.props.comingSoon) {
      return `Thanks! We will email you ${email}as soon as it's available`;
    }

    return `Thanks! We will email you ${email}when it's back in stock.`;
  }

  submit = () => {
    StockRemindersActions.setStockReminder(this.props.email || '', this.props.sku);
  }

  getForm() {
    if (!this.props.email) {
      return (
        <OutOfStockEmailForm
          customer={this.props.customer}
          sku={this.props.sku}
        />
      );
    }
    return (
      <button
        className="cta out-of-stock"
        type="submit"
        onClick={this.submit}
      >
        Notify me
      </button>
    );
  }

  render() {
    if (this.props.reminderSet) {
      return (
        <div className="reminder-set">
          <span className="bold">{this.getReminderText()}</span>
        </div>
      );
    }
    return (
      <div className="out-of-stock-reminder">
        <div className="bold">
          {this.getHeaderText()}
        </div>
        {this.getText()}
        {this.getForm()}
      </div>
    );
  }
}
